<template>
  <div
    class="main"
    data-app="true"
  >
    <v-app class="card">
      <v-container>
        <v-form
          ref="form"
          v-model="isApplicationFormValid"
          class="validation-border input-field"
          @submit.prevent="submit"
        >
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <h4 class="card-header">
                How much do you need?
              </h4>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <v-text-field
                id="dm-amount-input"
                v-model="form.amount"
                v-mask="currencyMask"
                :rules="rules.amountCheck"
                label="$1,000-$10,000"
                filled
                hide-details="auto"
                required
                class="amount_input input-field"
                validate-on-blur
              >
                <template
                  v-if="form.amount"
                  v-slot:append
                >
                  <v-icon
                    v-if="validAmount()"
                    class="mdi mdi-check"
                  />
                  <v-icon
                    v-else
                    class="mdi mdi-close"
                  />
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <h4 class="card-header">
                Let's check your address and phone number.
              </h4>
              </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <v-text-field
                v-model="form.home_address"
                :rules="rules.addressCheck"
                label="Street Address"
                filled
                hide-details="auto"
                required
                class="address_input input-field"
                validate-on-blur
              >
                <template
                  v-if="form.home_address"
                  v-slot:append
                >
                  <v-icon
                    v-if="form.home_address"
                    class="mdi mdi-check"
                  />
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <v-text-field
                id="dm-apt-input"
                v-model="form.apt_or_unit"
                label="Unit/Apt # (Optional)"
                filled
                hide-details="auto"
                class="unitapt_input input-field"
                validate-on-blur
              >
                <template
                  v-if="form.apt_or_unit"
                  v-slot:append
                >
                  <v-icon
                    v-if="form.apt_or_unit"
                    class="mdi mdi-check"
                  />
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <v-text-field
                v-model="form.postal_code"
                v-mask="'#####'"
                :rules="rules.zipcodeCheck"
                label="Zip Code"
                filled
                hide-details="auto"
                required
                class="zip_input input-field"
                validate-on-blur
              >
                <template
                  v-if="form.postal_code"
                  v-slot:append
                >
                  <v-icon
                    v-if="validZipcode()"
                    class="mdi mdi-check"
                  />
                  <v-icon
                    v-else
                    class="mdi mdi-close"
                  />
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              class="block-double-col"
              sm="5"
            >
              <v-text-field
                v-model="form.city"
                v-mask="cityMask"
                :rules="rules.cityCheck"
                label="City"
                class="city_input input-field"
                filled
                required
                hide-details="auto"
                validate-on-blur
              >
                <template
                  v-if="form.city"
                  v-slot:append
                >
                  <v-icon
                    v-if="form.city"
                    class="mdi mdi-check"
                  />
                </template>
              </v-text-field>
            </v-col>
            <v-col
              class="block-double-col"
              sm="3"
            >
              <v-select
                v-model="form.state"
                :items="states"
                :rules="rules.stateCheck"
                label="State"
                class="state_input input-field"
                filled
                hide-details="auto"
                required
                validate-on-blur
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <v-text-field
                id="dm-phone-input"
                v-model="form.main_phone"
                v-mask="'###-###-####'"
                data-social
                class="phone_input input-field"
                label="Phone"
                :rules="rules.phoneCheck"
                hide-details="auto"
                filled
                required
                validate-on-blur
              >
                <template
                  v-if="form.main_phone"
                  v-slot:append
                >
                  <v-icon
                    v-if="validPhone()"
                    class="mdi mdi-check"
                  />
                  <v-icon
                    v-else
                    class="mdi mdi-close"
                  />
                </template>
            </v-text-field>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col
              cols="8"
              class="one-col-row-mobile"
            >
            <h4 class="card-header">
              Do you rent or own?
            </h4>
            </v-col>
          </v-row>
            <v-row
              align="center"
              justify="center"
            >
              <v-col
                cols="4"
                :class="rentOrBuySelected ? 'btn-col': 'btn-col-err'"
              >
                <Radio
                  id="dm-rent-btn"
                  :class="{ selected: form.rent_or_own === 'rent' }"
                  icon="rent_icon"
                  label="I Rent"
                  :error="!rentOrBuySelected"
                  @click.native="toggle('rent')"
                />
              </v-col>
              <v-col
                cols="4"
                :class="rentOrBuySelected ? 'btn-col': 'btn-col-err'"
              >
                <Radio
                  id="dm-own-btn"
                  :class="{ selected: form.rent_or_own === 'own' }"
                  icon="own_icon"
                  label="I Own"
                  :error="!rentOrBuySelected"
                  @click.native="toggle('own')"
                />
              </v-col>
              <v-col
                class="one-col-row-mobile rent-or-buy-error"
                cols="8"
              >
                <p
                  v-show="!rentOrBuySelected"
                  class="submit-error"
                  >
                    Select your reason for borrowing a loan.
                </p>
              </v-col>
            </v-row>
          <v-row justify="center">
            <v-col
              cols="8"
              align="center"
              class="one-col-row-mobile"
            >
              <v-btn
                x-large
                color="#007EB1"
                class="confirm-btn"
                type="submit"
              >
                Continue
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import Radio from '../base/buttons/Radio.vue';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export function cityMask(value) {
  return [value.replace(/[^a-zA-Z.\-;:"/ ]/g, '')];
}

export default {
  name: 'AddressAmountCard',
  components: {
    Radio,
  },
  data() {
    return {
      isApplicationFormValid: false,
      rentOrBuySelected: true,
      form: {
        amount: this.$store.state.directMail.applicationData.amount,
        home_address: this.$store.state.directMail.applicationData.home_address,
        apt_or_unit: this.$store.state.directMail.applicationData.apt_or_unit,
        postal_code: this.$store.state.directMail.applicationData.postal_code,
        city: this.$store.state.directMail.applicationData.city,
        state: this.$store.state.directMail.applicationData.state,
        main_phone: this.$store.state.directMail.applicationData.main_phone,
        rent_or_own: this.$store.state.directMail.applicationData.rent_or_own,
      },
      cityMask,
      currencyMask: createNumberMask({
        prefix: '$',
        includeThousandsSeparator: true,
        allowNegative: false,
        thousandsSeparatorSymbol: ',',
        integerLimit: 5,
      }),
      states: ['','AK', 'AL', 'AR', 'AZ',
       'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID',
       'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN',
       'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV',
       'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX',
       'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY' ],
      rules: {
        amountCheck: [
          (val) => !!val ||
            'Enter the amount of money you would like to borrow.',
          (val) => this.validAmount((val || '')) ||
            'Enter an amount between $1,000 and $10,000.',
        ],
        addressCheck: [
          (val) => !!val || 'Enter your street address.',
        ],
        zipcodeCheck: [
          (val) => !!val || 'Enter your zip code.',
          (val) => this.validZipcode(val || '') || 'Enter a valid zip code.',
        ],
        cityCheck: [
          (val) => !!val || 'Enter your city.',
        ],
        phoneCheck: [
          (val) => !!val || 'Enter your phone number.',
          (val) => this.validPhone(val || '')||
           'Enter your 10-digit phone number.',
        ],
        stateCheck: [
          (val) => !!val || 'Select your state.',
        ],
      },
    };
  },
  methods: {
    validAmount(currentAmount = this.form.amount) {
      const intCurrentAmount = parseInt(currentAmount.replace(/[^0-9]/g, ''));
      return (intCurrentAmount >= 1000 && intCurrentAmount <= 10000);
    },
    validZipcode(zip = this.form.postal_code) {
      return zip.length == 5;
    },
    validPhone(phone = this.form.main_phone) {
      return phone.replace(/[^0-9]/g, '').length == 10;
    },
    toggle(selected) {
      this.rentOrBuySelected = true;
      if (selected === 'rent') {
        this.form.rent_or_own = 'rent';
      } else {
        this.form.rent_or_own = 'own';
      }
    },
    isReadyToSubmit() {
      this.rentOrBuySelected = this.form.rent_or_own !== ''
      return (this.isApplicationFormValid && this.rentOrBuySelected);
    },
    submit() {
      this.$refs.form.validate();
      if (this.isReadyToSubmit()){
        this.$store.commit('ADD_APPLICATION_DATA', this.form);
        this.$store.commit('SET_APPLY_CARD', 'account-creation-card');
        window.scrollTo(0,0);
      }
    },
  }
};
</script>

<style scoped lang="scss">

.card {
  background: #ffffff;
  position: relative;
  @media (max-width: 768px) {
    box-shadow: 0px;
    padding: 15px;
  }

  @media (min-width: 768px) {
    box-shadow: 0px 2px 3px #00000029;
    padding: 40px;
  }
}

.one-col-row-mobile {
  @media (max-width: 450px) {
    font: normal normal bold 16px/25px Open Sans;
    max-width: 100%;
    flex: 100%;
  }
}

.btn-col {
  @media (max-width: 450px) {
    flex: 50%;
    max-width: 50%;
  }
}

.btn-col-err {
  padding: 12px 12px 0px 12px;
  @media (max-width: 450px) {
    flex: 50%;
    max-width: 50%;
  }
}

.rent-or-buy-error {
  padding: 0px 12px 0px 12px;
}

.card-header {
  color: #333333;
  font-size: 18px;
  font: normal normal bold 18px/25px Open Sans;
  letter-spacing: 0px;
  opacity: 1;
  align-items: left;

  @media (max-width: 768px) {
    font: normal normal bold 16px/25px Open Sans;
  }
}

.block-double-col {
  @media (max-width: 599px) {
    max-width: 100%;
    flex: 100%;
  }
  @media (max-width:599px) and (min-width: 451px) {
    margin: 0 17%;
  }
}

.validation-border {
  ::v-deep .v-input__slot {
    border: 1px solid #A9A9A9 !important;
    background: #ffffff !important;
    
    fieldset {
      border: 1px solid #A9A9A9;
      background: #ffffff;
    }

    &:before, &:after {
      display: none;
    }
  }
  ::v-deep .v-input--has-state .v-input__slot{
    border: 1px solid #DB2435 !important;
  }
  ::v-deep .v-text-field__details {
    margin-bottom: 0px;
  }
  ::v-deep .primary--text{
    color: #007EB1 !important;
    caret-color: #333333 !important;
  }
  ::v-deep .error--text{
   color: #DB2435 !important;
   caret-color: #333333 !important;
  }
}

.submit-error {
  font-size: 12px;
  color: #DB2435 !important;
  caret-color: #DB2435 !important;
  text-align: right !important;
  word-break: break-word;
}

.input-field {
  border-radius: 5px;
  opacity: 1;
  color: #A9A9A9;

  font: normal normal normal 16px/28px Open Sans;
  letter-spacing: 0px;

  .corrected .v-label--active {
    top: 10px !important
  }
}

::v-deep .v-messages__message {
  text-align: right;
}

.mdi-close:before{
  color: #DB2435;
}
.mdi-check:before {
  color: #4EBB85;
}

.confirm-btn {
  color: #ffffff;
  border-radius: 5px;
  opacity: 1;
  background: #007eb1;
  border: 2px solid #007eb1;
  ::v-deep .v-btn__content {
    font-size: 26px;
    font-weight: 600;
    letter-spacing: 0px;
    text-align: center;
    text-transform: none;
    padding: 0px 33px;
  }
  &:hover,
  &:focus {
    background: #016c98;
    border: 2px solid #016c98;
  }
  &:active {
    box-shadow: 0 0 8px #007eb1;
    background-color: #007eb1 0% 0% no-repeat padding-box;
    border: 2px solid #007eb1;
    color: #ffffff;
  }
  &:disabled {
    background-color: #d7d7d7 0% 0% no-repeat padding-box;
    border: 2px solid #d7d7d7;
    color: #333333 !important;
  }
  @media (max-width: 375px) {
    max-width: 95%;
  }
}
</style>
